<!--TEAMS-424: KLW - For all instance of using buttonConfig check if not null with ?, otherwise errors will occur upon loading-->
<mat-toolbar class="tools noprint">
  <div class="left">
    @if (! this.Perspective) {
      <h1>{{title}}</h1>
    }

    @if (this.Perspective) {
      @if (this.PerspectiveLabel && (this.PerspectiveLabel.trim() !== '')) {
        <span class="perspective-label">{{this.PerspectiveLabel.trim()}}:</span>
      }
      <mat-select class="perspective-mat-select"
        [(ngModel)]="this.PerspectiveName"
        (ngModelChange)="this.perspectiveNameChanged()">
        @for (perspectiveName of this.PerspectiveNames; track perspectiveName) {
          <mat-option
            [value]="perspectiveName">
            {{perspectiveName}}
          </mat-option>
        }
      </mat-select>
    }

    @for (btn of buttonConfig?.left; track btn) {
      <button
        mat-button
        attr.aria-label="{{btn.label}}"
        disabled="{{btn.disabled === true}}"
        (click)="emitButtonClick($event, btn)"
        name="{{btn.value}}"
        id="listViewLeftIcons">
        @if (btn.icon == null) {
          <span>{{btn.label}}</span>
        }
        @if ((btn.icon != null) && (btn.iconFormat == 'MatIcon')) {
          <mat-icon title="{{btn.label}}">{{btn.icon}}</mat-icon>
        }
        @if ((btn.icon != null) && (btn.iconFormat == 'SvgIcon')) {
          <mat-icon svgIcon="{{btn.icon}}" class="default-svg-styling" title="{{btn.label}}"></mat-icon>
        }
      </button>
    }

    @if (DisplaySearch) {
      <form [formGroup]="this.FilterTermFormGroup" style="display:inline">
        <input matInput formControlName="filterTerm" placeholder="Search" autocomplete="off" class="search" />
      </form>
    }
  </div>

  <div class="right"
    id="listViewRightIcons">
    <!--(click)="emitButtonClick($event, btn.value)">-->
    <!-- TEAMS-653: KLW - Attribute binding for ngClass to set the value of cssClass of a ButtonConfig -->
    @for (btn of buttonConfig?.right; track btn) {
      <button
        [ngClass]="btn.cssClass"
        attr.aria-label="{{btn.label}}"
        mat-button class="toolbar-button-right"
        disabled="{{btn.disabled === true}}"
        (click)="emitButtonClick($event, btn)"
        name="{{btn.value}}">
        @if (btn.icon == null) {
          <span class="button-without-icon">{{btn.label}}</span>
        }
        @if (btn.icon != null) {
          @if (IsMaterialIconWithDefaultStyle(btn)) {
            <mat-icon title="{{btn.label}}">{{btn.icon}}</mat-icon>
          }
          @if (IsMaterialIconWithCustomStyle(btn)) {
            <mat-icon class="{{btn.iconDisplayStyle}}" title="{{btn.label}}">{{btn.icon}}</mat-icon>
          }
          @if (IsMaterialIconWithInlineStyle(btn)) {
            <mat-icon style="{{btn.inlineStyles}}" title="{{btn.label}}">{{btn.icon}}</mat-icon>
          }
          @if (IsSvgIconWithNoInlineStyles(btn)) {
            <mat-icon svgIcon="{{btn.icon}}" class="default-svg-styling" title="{{btn.label}}"></mat-icon>
          }
          @if (IsSvgIconWithInlineStyles(btn)) {
            <mat-icon svgIcon="{{btn.icon}}" class="default-svg-styling" title="{{btn.label}}" style="{{btn.inlineStyles}}"></mat-icon>
          }
        }
      </button>
    }

    @if (this.HasTrashCan) {
      <!--<mat-icon svgIcon="vertical-line" class="left-vertical-divider-mat-icon"></mat-icon>-->
      <div class="drop-area center-icon" [ngClass]="this.ItemIsBeingDragged ? 'enabled-trash-can-mat-icon' : 'disabled-trash-can-mat-icon'"
        droppable
        [dropScope]="['item']"
        (onDrop)="this.onItemDroppedOnTrash($event)">
        <!-- <mat-icon svgIcon="trash" class="toolbar-button-right"></mat-icon> -->
        <i [appIcon] class="toolbar-button-right" svgIcon="trash" appIconItemType="{{this.iconType}}"></i>
      </div>
      <!--<mat-icon svgIcon="vertical-line" class="right-vertical-divider-mat-icon"></mat-icon>-->
    }

    <!-- 08-05-2022 SWH note:  added the following, optional 'navigation' buttons. -->
    <!--(click)="emitButtonClick($event, btn.value)"-->
    @for (btn of buttonConfig?.navigation; track btn) {
      <button
        mat-button class="toolbar-button-right"
        attr.aria-label="{{btn.label}}"
        disabled="{{btn.disabled === true}}"
        (click)="emitButtonClick($event, btn)">
        @if (btn.icon == null) {
          <span>{{btn.label}}</span>
        }
        @if (btn.icon != null) {
          @if ((btn.icon != null) && (btn.iconFormat == 'MatIcon') && (btn.iconDisplayStyle == 'Default')) {
            <mat-icon title="{{btn.label}}">{{btn.icon}}</mat-icon>
          }
          @if ((btn.icon != null) && (btn.iconFormat == 'MatIcon') && (btn.iconDisplayStyle != 'Default')) {
            <mat-icon class="{{btn.iconDisplayStyle}}" title="{{btn.label}}">{{btn.icon}}</mat-icon>
          }
          @if ((btn.icon != null) && (btn.iconFormat == 'SvgIcon')) {
            <mat-icon svgIcon="{{btn.icon}}" class="default-svg-styling" title="{{btn.label}}"></mat-icon>
          }
        }
      </button>
    }

    <!-- End 08-05-2022 change. -->

    @if (this.View==='tile') {
      <button mat-button
        aria-label="Sort"
        title="Sort"
        [matMenuTriggerFor]="sortMenu"
        >
        <mat-icon>sort_by_alpha</mat-icon>
      </button>
    }

    @if (viewOverride == null) {
      <button
        mat-button
        [matMenuTriggerFor]="viewsMenu"
        aria-label="View Mode Menu"
        title="View Mode Menu"
        >
        @if (view==='tile') {
          <mat-icon class="view-menu-mode-icon">view_module</mat-icon>
        }
        @if (view==='grid') {
          <mat-icon class="view-menu-mode-icon">view_list</mat-icon>
        }
      </button>
    }
  </div>
</mat-toolbar>

<div id="listViewMenuBar">
  <mat-menu #viewsMenu="matMenu">
    <button mat-menu-item (click)="setView('tile')" [ngClass]="{selectedMenu: this.View==='tile'}"><mat-icon>view_module</mat-icon>Tile</button>
    <button mat-menu-item (click)="setView('grid')" [ngClass]="{selectedMenu: this.View==='grid'}"><mat-icon>view_list</mat-icon>Grid</button>
  </mat-menu>
  <mat-menu #sortMenu="matMenu">
    <button
      mat-menu-item
      aria-label="Sort ascending"
      title="Sort ascending"
      (click)="setSortDirection('asc')"
      [ngClass]="{selectedMenu: sortDirection==='desc'}"><mat-icon>arrow_upward</mat-icon>A → Z</button>
      <button
        mat-menu-item
        aria-label="Sort descending"
        title="Sort descending"
        (click)="setSortDirection('desc')"
        [ngClass]="{selectedMenu: sortDirection==='asc'}"><mat-icon>arrow_downward</mat-icon>Z → A</button>
      </mat-menu>
    </div>

    <div class="list-view-content"
      id="listViewContent">
      @if (this.View==='tile') {
        <app-tile-view
          [list]="this.ListItems"
          [listType]="listType"
          [listItemsAreDraggable]="listItemsAreDraggable"
          [defaultSortColumn]="defaultSortColumn"
          [filterTerm]="this.FilterTerm"
          [selectedItemId]="selectedId"
          [itemActionButtons]="buttonConfig?.item_actions"
          [parentTitle]="title"
          [hasCheckboxes]="this.hasCheckboxes"
          [hideActionButtons]="this.hideActionButtons"
          [typeSortOrderConfig]="typeSortOrderConfig"
          [sortDirection]="GetSortDirection"
          [currentFolder]="this.currentFolder"
          (editClick)="editClick.emit($event)"
          (itemActionClick)="itemActionClick.emit($event)"
          (dragAction)="this.onDragAction($event)"
          (sortChange)="this.handleSortChange($event)"
          [totalListCount]="this.totalListCount"
          (itemContextMenu)="this.onItemContextMenu($event)"
          (itemMoved)="this.onItemMoved($event)"
          (filesDropped)="this.onFileDropped($event)"
          (selectionsSet)="this.setSelections($event)">
        </app-tile-view>
      }
      @if (this.View==='grid') {
        <app-grid-view
          [list]="this.ListItems"
          [listType]="listType"
          [listItemsAreDraggable]="listItemsAreDraggable"
          [defaultSortColumn]="defaultSortColumn"
          [filterTerm]="this.FilterTerm"
          [selectedItemId]="selectedId"
          [itemActionButtons]="buttonConfig?.item_actions"
          [columnsConfig]="columnsConfig"
          [typeSortOrderConfig]="typeSortOrderConfig"
          [parentTitle]="title"
          [hasCheckboxes]="this.hasCheckboxes"
          [maxSelection]="this.maxSelection"
          [renderNameAsLink]="this.renderNameAsLink"
          (exceededMaxSelection)="this.exceededMaxSelection.emit()"
          [hideActionButtons]="this.hideActionButtons"
          [currentFolder]="this.currentFolder"
          [configuredStructureFields]="this.configureStructureFields"
          (editClick)="editClick.emit($event)"
          (itemActionClick)="itemActionClick.emit($event)"
          (dragAction)="this.onDragAction($event)"
          (sortChange)="this.handleSortChange($event)"
          [totalListCount]="this.totalListCount"
          (itemContextMenu)="this.onItemContextMenu($event)"
          (itemMoved)="this.onItemMoved($event)"
          (filesDropped)="this.onFileDropped($event)"
          (selectionsSet)="this.setSelections($event)">
        </app-grid-view>
      }
      <div [ngClass]="{'hidden':!DisplayInfiniteScrollSentinel}" #infiniteScrollSentinel class="infinite-scroll-sentinel">
        <div class="loading-more" (click)="forceLoadMore()">Load more...</div>
      </div>
    </div>
